import { ArrowLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface MergePageHeaderProps {
  currentStep: 'select' | 'preview';
  destinationId: string;
  isLoading: boolean;
  onCancel: () => void;
  onBack: () => void;
  onNext: () => void;
  onMerge: () => void;
}

export const MergePageHeader = ({
  currentStep,
  destinationId,
  isLoading,
  onCancel,
  onBack,
  onNext,
  onMerge,
}: MergePageHeaderProps) => {
  return (
    <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Button variant="ghost" size="sm" onClick={onCancel}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Cancel
            </Button>

            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <span
                className={`${
                  currentStep === 'select'
                    ? 'font-medium text-blue-600'
                    : 'text-gray-900'
                }`}
              >
                Select Destination
              </span>
              <ChevronRight className="h-4 w-4" />
              <span
                className={`${
                  currentStep === 'preview'
                    ? 'font-medium text-blue-600'
                    : 'text-gray-500'
                }`}
              >
                Review & Merge
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            {currentStep === 'select' ? (
              <Button
                onClick={onNext}
                disabled={!destinationId}
                className="bg-blue-600 hover:bg-blue-700"
              >
                Next: Review
              </Button>
            ) : (
              <>
                <Button variant="outline" onClick={onBack}>
                  Back
                </Button>
                <Button
                  onClick={onMerge}
                  disabled={isLoading}
                  className="bg-red-600 hover:bg-red-700"
                >
                  {isLoading ? 'Merging...' : 'Merge Providers'}
                </Button>
              </>
            )}
          </div>
        </div>

        <div className="mt-4">
          <h1 className="text-2xl font-bold text-gray-900">
            Merge Medical Providers
          </h1>
          <p className="mt-1 text-sm text-gray-600">
            {currentStep === 'select'
              ? 'Select which provider should be the destination for the merge. All other providers will be merged into it.'
              : 'Review the merge operation below. This action cannot be undone.'}
          </p>
        </div>
      </div>
    </div>
  );
};
